import { ShieldCheck, ExternalLink } from "lucide-react";
import { CERTIFICATIONS } from "@/data/site";
import { Reveal, Eyebrow } from "@/components/Reveal";
import { useI18n } from "@/context/I18nContext";

export default function Certifications() {
  const { t } = useI18n();
  return (
    <section id="certifications" data-testid="certifications-section" className="relative z-10 mx-auto max-w-7xl px-6 lg:px-10 py-28 lg:py-40">
      <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6">
        <div>
          <Reveal><Eyebrow>{t("cert_eyebrow")}</Eyebrow></Reveal>
          <Reveal delay={0.05}>
            <h2 className="mt-5 font-display text-4xl sm:text-5xl lg:text-6xl tracking-tight text-brand-fg max-w-2xl leading-[1.02]">
              {t("cert_title1")} <span className="text-brand-gold italic">{t("cert_title2")}</span>
            </h2>
          </Reveal>
        </div>
        <Reveal delay={0.1}><p className="max-w-sm text-brand-fg/70 text-sm leading-relaxed">{t("cert_intro")}</p></Reveal>
      </div>

      <div className="mt-14 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {CERTIFICATIONS.map((c, i) => (
          <Reveal key={c.name} delay={i * 0.06}>
            <a href={c.file} target="_blank" rel="noreferrer" data-testid={`cert-card-${i}`} className="group flex h-full flex-col rounded-2xl border border-brand-border bg-brand-card p-7 hover:border-brand-gold/50 hover:shadow-md transition-all shadow-sm">
              <div className="flex items-start justify-between">
                <span className="grid place-items-center h-12 w-12 rounded-full bg-brand-goldSoft text-brand-gold group-hover:bg-brand-gold group-hover:text-white transition-colors">
                  <ShieldCheck size={20} />
                </span>
                <ExternalLink size={16} className="text-brand-fg/30 group-hover:text-brand-gold transition-colors" />
              </div>
              <h3 className="mt-5 font-display text-2xl text-brand-fg">{c.name}</h3>
              <p className="mt-2 text-sm text-brand-fg/60 leading-relaxed flex-1">{c.full}</p>
              <div className="mt-5 border-t border-brand-border pt-4">
                <div className="font-mono text-xs text-brand-gold break-all">{c.number}</div>
                <div className="mt-1 text-xs text-brand-fg/50">{c.validity}</div>
              </div>
            </a>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
